module.exports = __webpack_public_path__ + "static/media/expand.b671698f.svg";